import styled from 'styled-components'
import { motion } from 'framer-motion'
import { Box } from 'src/components'

export const ContentSelect = styled(motion(Box))`
    height: auto;
    position: relative;
    width: 80px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 175px;
        justify-content: center;
        display: flex;
        word-wrap: break-word;
    }
`
